// TemplatePicker.jsx — empty-state segment starter cards
//
// Rendered above the RuleGroup in segmentEditor when the current segment has
// no rules yet. Each card shows a template's name + description; clicking
// applies its ruleTree (and optionally prefills name/description if the
// segment is still un-named).
import React from 'react';
import { SEGMENT_TEMPLATES } from '../helpers/segmentTemplates.js';
import {
    Crown, Sparkles, ShoppingCart, RefreshCcw, Wallet, Star, Clock, Car, LayoutGrid,
} from 'lucide-react';

const ICON_MAP = {
    crown: Crown,
    sparkles: Sparkles,
    'shopping-cart': ShoppingCart,
    'refresh-ccw': RefreshCcw,
    wallet: Wallet,
    star: Star,
    clock: Clock,
    car: Car,
};

const TemplatePicker = ({ onApply, currentName }) => {
    const applyTemplate = (t) => {
        // Only overwrite name/description if the user hasn't typed anything.
        const patch = { ruleTree: t.ruleTree };
        if (!currentName || !currentName.trim()) {
            patch.name = t.name;
            patch.description = t.description;
        }
        onApply(patch);
    };

    return (
        <div className="mb-3">
            <div className="d-flex align-items-center mb-2" style={{ gap: 6, color: '#525f7f' }}>
                <LayoutGrid size={14} />
                <strong className="small">Start from a template</strong>
                <span className="text-muted small">— or build from scratch below</span>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 8 }}>
                {SEGMENT_TEMPLATES.map(t => {
                    const Icon = ICON_MAP[t.icon] || LayoutGrid;
                    return (
                        <button
                            key={t.id}
                            type="button"
                            onClick={() => applyTemplate(t)}
                            style={{
                                textAlign: 'left',
                                border: '1px solid #e6e9ef',
                                borderRadius: 6,
                                padding: '10px 12px',
                                background: '#fff',
                                cursor: 'pointer',
                                transition: 'border-color 0.15s, box-shadow 0.15s',
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.borderColor = '#4c8bf5';
                                e.currentTarget.style.boxShadow = '0 2px 8px rgba(76, 139, 245, 0.08)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.borderColor = '#e6e9ef';
                                e.currentTarget.style.boxShadow = 'none';
                            }}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4, color: '#4c8bf5' }}>
                                <Icon size={16} />
                                <strong style={{ fontSize: 13, color: '#32325d' }}>{t.name}</strong>
                            </div>
                            <div style={{ fontSize: 12, color: '#8898aa', lineHeight: 1.4 }}>
                                {t.description}
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default TemplatePicker;
